module.exports = __webpack_public_path__ + "static/media/ms-icon-150x150.3fce30ff.png";